import { render } from "./LookforPassword.vue?vue&type=template&id=b90a2062&scoped=true"
import script from "./LookforPassword.vue?vue&type=script&lang=js"
export * from "./LookforPassword.vue?vue&type=script&lang=js"

import "./LookforPassword.vue?vue&type=style&index=0&id=b90a2062&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b90a2062"]])

export default __exports__